import { SpinnerSize } from "./type";

export const getSpinnerSize = (size?: SpinnerSize) => {
  switch (size) {
    case "xLarge":
      return "3rem";
    case "large":
      return "2rem";
    case "medium":
      return "1.5rem";
    case "small":
    default:
      return "1rem";
  }
};

export const getSpinnerStrokeWidth = (size?: SpinnerSize) => {
  switch (size) {
    case "xLarge":
      return 1.5;
    case "large":
      return 2;
    case "medium":
      return 2.5;
    case "small":
    default:
      return 3;
  }
};
